import styled from 'styled-components';

import Colours from '/shared/styled/Colours';

export default styled.div`
  background: ${Colours.whiteDark1};
  border: 1px solid ${Colours.greyLight8};
  padding: 2rem 3rem 3rem;
  max-width: 49rem;
  min-width: 50%;

  ul {
    display: table;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: table-row;

      div {
        display: table-cell;
        padding-right: 1.5rem;

        &:last-child {
          font-weight: bold;
        }
      }

      &:last-child div {
        font-weight: bold;

        &:last-child {
          color: ${Colours.green};
        }
      }
    }
  }
`;
